import { gql } from "@apollo/client";

export type ReportParameterValue = {
  key: string;
  value?: string;
};

export type ScheduledReportInput = {
  id: number;
  sqlFunctionName: string;
  marketplaceId?: number;
  hour: string;
  schedule: string;
  emails: string[];
}

export type ScheduledReportFilter = {
  reportName?: string;
  sqlFunctionName?: string;
}

export const getReportsQuery = gql`
  query getReports {
    getReports {
      key
      name
      parameters {
        key
        label
        nullable
        type
      }
    }
  }
`;

export const getReportDataQuery = gql`
  query getReportData($params: [ReportParameterValue!]!, $key: String!) {
    getReportData(params: $params, key: $key)
  }
`;

export const getScheduledReportsQuery = gql`
  query getScheduledReports($filter: ScheduledReportFilter, $pagination: PaginationInfo) {
    getScheduledReports(filter: $filter, pagination: $pagination) {
      scheduledReports {
        id
        name
        hour
        emails
        schedule
        marketplaceId
        marketplaceName
        sqlFunctionName
      }
      totalCount
    }
  }
`;

export const deleteScheduledReportsMutattion = gql`
  mutation deleteScheduledReports($id: Float!) {
    deleteScheduledReports(id: $id)
  }
`;

export const createScheduledReportsMutattion = gql`
  mutation createScheduledReports($data: ScheduledReportInput!) {
    createScheduledReports(data: $data) {
      id
      name
      hour
      emails
      schedule
      marketplaceId
      sqlFunctionName
    }
  }
`;

export const editScheduledReportsMutattion = gql`
  mutation editScheduledReports($data: ScheduledReportInput!) {
    editScheduledReports(data: $data) {
      id
      name
      hour
      emails
      schedule
      marketplaceId
      sqlFunctionName
    }
  }
`;

export const generateOnDemandReportQuery = gql`
  query generateOnDemandReport($id: Float!) {
    generateOnDemandReport(id: $id)
  }
`;
